export const firestoreKeys = Object.freeze({
  Admin: 'Admin',
  Students:'Students',
  SCHOOLS: 'schools',
  CLASSES: 'classes',
  TEACHERS: 'teachers',
  PARENTS: 'parents',
  SCHOOL_ADMINS: 'school-admins',
  SUPPORT_TICKETS: 'SupportTickets',
  MAIL: 'mail',
});

export const toastSeverity = Object.freeze({
  ERROR: 'error',
  WARNING: 'warning',
  INFO: 'info',
  SUCCESS: 'success',
});

export const firebaseErrorCodes = Object.freeze({
  EMAIL_IN_USER: 'auth/email-already-in-use',
});

export const CITY_OPTIONS = ['All', 'Cape Town', 'Stellenbosch'];

export const SUPPORT_TICKET_LIST_COLUMNS = [
  { id: 'date', label: 'Date', align: 'left' },
  { id: 'name', label: 'Name', align: 'left' },
  { id: 'emailAddress', label: 'Email Address', align: 'left' },
  { id: 'message', label: 'Message', align: 'left' },
  { id: 'status', label: 'Status', align: 'left' },
];
export const appColors = {
  base: {
    black: '#000',
    white: '#fff',
  },
  brand: {
    blue: '#22AAE1',
    darkGrey: '#58595b',
  },
  menu: {
    background: '#5D5E60',
    selectedHover: '#8dc63f66', // brand green with 0.4 opacity
  },
};

// Route paths for site - see routeKeys for export and implementation
const paths = {
  actions: {
    create: '/create',
    delete: '/delete',
    edit: '/edit',
    details: '/details',
    list: '/list',
    permissionDenied: '/permission-denied',
    resetPassword: '/reset-password',
    unprotected: '/login-unprotected',
  },
  errorPages: {
    page403: '/403',
    page404: '/404',
    page500: '/500',
  },
  pages: {
    admin: '/admin',
    app: '/app',
    auth: '/auth',
    bookings: '/bookings',
    dashboard: '/dashboard',
    login: '/login',
    logout: '/logout',
    modules: '/modules',
    myLearning: '/my-learning',
    register:'/register',
    students: '/students',
    support: '/support-ticket',
  },
  courses: {
    advancedDescriptQuant: '/Advanced-Descriptive-Quantification',
    closeOutProcess: '/Close-Out-Processes-on-Built-Environment-Projects',
    costInfo: '/Cost-Information-Databases',
    disputeRes: '/Dispute-Resolution-in-the-South-African-Construction-Industry',
    financialFeasibility: '/Financial-Feasibility-Studies-for-Built-Environment-Projects',
    lifeCyleCosting: '/Life-Cycle-Costing-and-Value-Management',
    procurment: '/Procurement-Advice-and-Price-Determination',
    propertyLaw: '/Property-Law-and-Valuations-in-South-Africa',
    qualityAssurance: '/Quality-Assurance-for-Built-Environment-Projects',
    research: '/Research-Methodology',
    riskManagement: '/Risk-Management-on-Built-Environment-Projects',
    strategicPlanning: '/Strategic-Planning-for-Built-Environment-Projects',
  },
};

export const courses = [
  {
    name: 'Advanced Descriptive Quantification',
    path: paths.courses.advancedDescriptQuant,
  },
  {
    name: 'Close Out Processes on Built Environment Projects',
    path: paths.courses.closeOutProcess,
  },
  {
    name: 'Cost Information Databases',
    path: paths.courses.costInfo,
  },
  {
    name: 'Dispute Resolution in the South African Construction Industry',
    path: paths.courses.disputeRes,
  },
  {
    name: 'Financial Feasibility Studeis For Built Environment Projects',
    path: paths.courses.financialFeasibility,
  },
  {
    name: 'Life Cycle Costing & Value Management',
    path: paths.courses.lifeCyleCosting,
  },
  {
    name: 'Procurement Advice & Price Determination',
    path: paths.courses.procurment,
  },
  {
    name: 'Property Law and Valuations in South Africa',
    path: paths.courses.propertyLaw,
  },
  {
    name: 'Quality Assurance for Built Environment Projects',
    path: paths.courses.qualityAssurance,
  },
  {
    name: 'Research Methodology',
    path: paths.courses.research,
  },
  {
    name: 'Risk Management on Built Environment Projects',
    path: paths.courses.research,
  },
  {
    name: 'Strategic Planning for Built Environment Projects',
    path: paths.courses.strategicPlanning,
  },
];

export const routeKeys = {
  ...paths.actions,
  ...paths.errorPages,
  ...paths.pages,
  ...paths.courses
};

export const pageTitles = {
  bookings: 'Bookings',
  home: 'Home',
  modules: 'Modules',
  students: 'Students',
  support: 'Support Tickets',
};

export const passwordRegex = '^(?=.*[a-z])(?=.*[A-Z])(?=.*d)(?=.*[@$!%*?&+-/`~<>=])[A-Za-zd@$!%*?&]{8,}$';

/*
Courses:[
{ name:,
 url:
},
{ name:,
 url,
}
]
*/